// Timing for the post-stream word reveal: each chunk (one word, or a whole
// non-text block like a code block) lands behind the previous one. The
// stagger shrinks for long answers so the full reveal never spreads past
// CHUNK_REVEAL_MAX_TOTAL_MS — every chunk stays sequential instead of the
// tail snapping in at a clamp.
// Keep CHUNK_REVEAL_DURATION_MS in sync with final-reveal.css.
export const CHUNK_REVEAL_DURATION_MS = 80
export const CHUNK_REVEAL_STAGGER_MS = 12
export const CHUNK_REVEAL_MAX_TOTAL_MS = 3000

/**
 * Per-chunk animation delays for a reveal pass. Chunks below
 * `alreadyRevealedCount` were shown by a previous pass (text grew mid-reveal)
 * and get zero delay; fresh chunks stagger from zero so the reveal continues
 * where it left off instead of replaying from the top.
 */
export function computeChunkDelays(chunkCount: number, alreadyRevealedCount: number): Array<number> {
  const fresh = Math.max(0, chunkCount - alreadyRevealedCount)
  const stagger = fresh > 1 ? Math.min(CHUNK_REVEAL_STAGGER_MS, CHUNK_REVEAL_MAX_TOTAL_MS / (fresh - 1)) : 0
  const delays: Array<number> = []
  for (let i = 0; i < chunkCount; i++) {
    const staggerIndex = i - Math.min(alreadyRevealedCount, chunkCount)
    delays.push(staggerIndex <= 0 ? 0 : Math.round(staggerIndex * stagger))
  }
  return delays
}
